import { Card, CardContent, CardHeader, LabelValueList, Typography, useRouter } from '@forgeglobal/design-framework'
import { formatAbbreviatedMoney } from 'util/NumberUtils'
import { orderAssetTypeOptions } from 'util/Enums'
import { useIssuerTradeSummaryQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

export const IssuerTradeSummary: React.FC = props => {
  const { match } = useRouter<{ id: string }>()
  const { data } = useIssuerTradeSummaryQuery({ variables: { id: match.params.id } })
  const summary = data?.account?.issuer_account?.transaction_summary

  const itemContent = summary
    ? [
        {
          label: 'Traded before',
          value: 'Yes',
        },
        {
          label: 'Structures',
          value:
            summary &&
            summary.trade_asset_types.split(',').map((assetType: string) => {
              const asset = orderAssetTypeOptions.find(asset => asset.value === assetType)
              return (
                <Typography variant="body1" align="right" key={assetType}>
                  {asset ? asset.label : 'Unknown'}
                </Typography>
              )
            }),
        },
        {
          label: 'Total trade volume',
          value: summary && `${formatAbbreviatedMoney(summary.total_trade_volume)}`,
        },
        {
          label: 'Number of trades',
          value: summary && summary.total_trades.toString(),
        },
      ]
    : [
        {
          label: 'Traded before',
          value: 'No',
        },
      ]

  return (
    <Card>
      <CardHeader title="Trade Summary" />
      <CardContent>
        <LabelValueList items={itemContent} />
      </CardContent>
    </Card>
  )
}
